import { throttle } from '../utils';
import { mobileProductList } from './product-list-mobile';
import { checkforSlidersInProductList } from './slick-sliders';

export default function productListFunctionality() {
  if (!document.querySelector('.product-list')) return;

  mobileProductList();

  initScrollTrigger();
  initFetchAllProducts();
  removeAjaxBuyOnBundleProducts();
  changeHtmlForSearchPagination();
  productBundlePriceProdlist();
  initFaqBlockFunctionality();
  addHtmlToColorChoiceProducts();
  addClickHandlerToProductList();
}

let showScrollToTopBtn = false;
let isFetching = false;

function initFetchAllProducts() {
  if (!document.querySelector('.woocommerce-pagination')) return;

  const prodlist = document.querySelector('.product-list');
  const currentPage = document.querySelector('.latest-products')
    ? 'latest-products'
    : document.querySelector('body').classList.contains('search-results')
      ? 'search-page'
      : 'product-page';

  attachLoadMoreButton();
  attachLoadMoreBtnHandler(prodlist, currentPage);
  maybeTriggerScrollToProduct();
}

function maybeTriggerScrollToProduct() {
  if (!sessionStorage.getItem('currentUrl')) return;

  const urlParts = sessionStorage.getItem('currentUrl').split('_wl-product-index_');
  if (urlParts.length > 1 && urlParts[0] === window.location.href) {
    const loadMoreBtn = document.getElementById('ajax-load-more-products-btn');
    loadMoreBtn.click();
  }
}

function attachLoadMoreButton() {
  const loadMoreProductsButtonContainer = document.createElement('div');
  loadMoreProductsButtonContainer.className = 'load-more-products-btn-container';

  const loadMoreProductsButton = document.createElement('button');
  loadMoreProductsButton.textContent = document.documentElement.lang == 'sv-SE' ? 'Visa alla' : 'Show all';
  loadMoreProductsButton.className = 'wl-button';
  loadMoreProductsButton.id = 'ajax-load-more-products-btn';

  loadMoreProductsButtonContainer.appendChild(loadMoreProductsButton);

  document.querySelector('.product-list .products').after(loadMoreProductsButtonContainer);
}
function attachLoadMoreBtnHandler(prodlist, currentPage) {
  document.getElementById('ajax-load-more-products-btn').addEventListener('click', function () {
    if (isFetching) return;

    this.classList.add('--is-loading');
    currentPage === 'latest-products' || currentPage === 'product-page'
      ? getMoreProducts(prodlist, currentPage)
      : getMoreSearchProducts(prodlist);
  });
}

function getMoreProducts(prodlist, currentPage) {
  isFetching = true;

  const data = getPostDataDependingOnPage(currentPage);

  if (!data) return;

  $.post(
    ajax_handler.ajaxurl,
    data,
    function (response) {
      response ? handleLazyLoadResponse(prodlist, response) : console.error('Något gick fel när fler produkter skulle hämtas med Ajax');
    },
    'json'
  );
}

function getPostDataDependingOnPage(currentPage) {
  switch (currentPage) {
    case 'product-page':
      return {
        action: 'get_more_products',
        category: getCategoryFromHeader()
      };
    case 'latest-products': {
      // Det läggs ut en global variabel nu från latest-products-blocket som vi snappar upp i nästa funktion
      const productCount = document.querySelectorAll('.product-list .product').length;
      const latestProductIdsArray = getNewsProductIds();

      if (latestProductIdsArray.length === 0) {
        return false;
      }

      return {
        action: 'get_more_products_news',
        product_ids: latestProductIdsArray,
        count: productCount
      };
    }
  }
}

function getNewsProductIds() {
  if (typeof allNewProductIDs === 'undefined') return [];

  const productIdCopy = [...allNewProductIDs]; // denna är global. Borde kunna hämta alla i en och samma fråga!
  const productIdsInNextView = productIdCopy;

  return productIdsInNextView.map(function (prodObj) {
    if (!prodObj) return false;

    if (typeof prodObj === 'object') return prodObj.product;

    return prodObj;
  });
}

function getCategoryFromHeader() {
  const url = new URL(window.location.href);
  const allUrlParts = url.href.split('/').filter((x) => x !== '');
  return allUrlParts.slice(allUrlParts.length - 1)[0];
}

function handleLazyLoadResponse(prodlist, [productHtml, moreProducts]) {
  if (productHtml)
    // Om det finns precis 20 produkter i listan så kommer man få null här men success i anropet.
    prodlist.querySelector('.products').insertAdjacentHTML('beforeend', productHtml);

  isFetching = false;

  renderProductDetailsAfterLoad();
}

function removeLoadMoreButton() {
  const loadMoreProductsButtonCont = document.querySelector('.load-more-products-btn-container');
  if (loadMoreProductsButtonCont) loadMoreProductsButtonCont.parentNode.removeChild(loadMoreProductsButtonCont);
}

function getMoreSearchProducts() {
  // Iden är att ta ut alla länkar ur sökpagineringarna och hämta dessa med Ajax. Kan ta enorm tid med fler sökresultat så kanske måste ha en hantering av detta?
  const paginationLinks = getAllPaginationLinks();

  if (paginationLinks.length === 0) return;

  isFetching = true;

  const searchPagePromises = paginationLinks.map((url, index) =>
    $.get(url)
      .then((productData) => ({ index, productData }))
      .fail((xhr) => {
        console.error('Något gick fel vid hämtning av data från ' + url + ' ', xhr.status, xhr.statusText);
        return null;
      })
  );

  Promise.all(searchPagePromises)
    .then((results) => {
      results
        .filter((result) => result !== null) // Om en hämtning skiter sig så sätter vi dessa excplicit till null ovanför
        .sort((a, b) => a.index - b.index) // Sortera efter index för att visa dessa i samma ordning som de hämtats.
        .forEach(({ productData }) => {
          const products = $(productData).find('.product');
          $('.product-list .products').append(products);
        });

      renderProductDetailsAfterLoad();
    })
    .finally(() => {
      isFetching = false;
    });
}

function renderProductDetailsAfterLoad() {
  productBundlePriceProdlist();
  // productBundleSkuProdulist();
  removeAjaxBuyOnBundleProducts();
  addHtmlToColorChoiceProducts();

  mobileProductList();

  removeLoadMoreButton();
  removePagination();
  removeDuplicateProducts();

  checkIfShouldScrollToProd();

  setTimeout(() => {
    checkforSlidersInProductList();
  }, 1000); // Kör denna på rejäl timeout. Har inget bra sätt att avgöra när DOMen är redo för att initiera slidern
}

function checkIfShouldScrollToProd() {
  if (sessionStorage.getItem('currentUrl')) {
    const urlParts = sessionStorage.getItem('currentUrl').split('_wl-product-index_');

    if (urlParts.length > 1 && urlParts[0] === window.location.href) {
      const productAtIndex = document.querySelector(`.product-list .product:nth-child(${parseInt(urlParts[1]) + 1})`);

      if (productAtIndex) productAtIndex.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  sessionStorage.removeItem('currentUrl');
}

function removePagination() {
  const pagination = document.querySelector('.woocommerce-pagination');
  if (pagination) pagination.remove();
}

function getAllPaginationLinks() {
  const paginationLinks = [];

  for (const paginationLink of document.querySelectorAll('.woocommerce-pagination a.page-numbers:not(.next)')) {
    paginationLinks.push(paginationLink.href);
  }

  return paginationLinks;
}

function initScrollTrigger() {
  document.addEventListener('scroll', throttle(handleScrollToTopBtn, 100));
}

function handleScrollToTopBtn() {
  if (window.scrollY > window.innerHeight && !showScrollToTopBtn) {
    showScrollToTopBtn = true;
    appendScrollToTopBtnHtml();
    // TODO Visa och dölj med css istället, nu kommer elementet ligga detached i browsern varje gång den tas bort.
  } else if (window.scrollY < window.innerHeight && showScrollToTopBtn) {
    document.getElementById('scrollToTopBtn').remove();
    showScrollToTopBtn = false;
  }
}

function appendScrollToTopBtnHtml() {
  const scrollToTopBtn = document.createElement('button');
  scrollToTopBtn.id = 'scrollToTopBtn';
  scrollToTopBtn.textContent = '∧';
  scrollToTopBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  document.body.append(scrollToTopBtn);
}

function removeAjaxBuyOnBundleProducts() {
  $('.product_type_bundle.ajax_add_to_cart').removeClass('ajax_add_to_cart');
}

export function productBundlePriceProdlist() {
  const langIsEnglish = $('html').attr('lang') == 'en-US';
  $('.products .product, .related-item').each(function () {
    if ($('.bundled-item-prices-prodlist', this).length > 0) {
      let price = '';

      $('.bundle-price .product-price', this).each(function () {
        if ($(this).text() != '') {
          price = $(this).text();
          // Return false Bryter loopen i jquery
          return false;
        }
      });

      if (price.length == 0 || price == '0' || $('span.price', this).length == 0) return;

      const bundlePriceHtml = `<span class="bundle-price-label">${langIsEnglish ? 'From' : 'Från'} </span>` + price;
      $('span.price', this).html(bundlePriceHtml);
    }
  });
}

export function productBundleSkuProdulist() {
  $('.products .product, .related-item').each(function () {
    if ($('.bundled-item-skus-prodlist', this).length > 0) {
      const sku = $('.bundle-sku', this).first().text();
      $('.product-sku', this).hide();
      $('.single-product-info .woocommerce-loop-product__title', this).after('<span class="product-sku bundle-sku">' + sku + '</span>');
    }
  });
}

function changeHtmlForSearchPagination() {
  const target = $('.pagination-container .pagination-div .pagination .page-numbers');
  if (target.length) {
    $('.search-page-wrapper').addClass('pagination_exists');
    const textNext = target.last().text();
    const textPrev = target.first().text();
    if (textNext == 'Nästa »' || textNext == 'Next »') {
      target.last().text('→');
    }
    if (textPrev == '« Föregående' || textPrev == '« Previous') {
      target.first().text('←');
    }
  } else {
    $('.pagination-container').addClass('hide');
  }
}

function initFaqBlockFunctionality() {
  const faqBlockContainer = document.querySelector('.wl-faq-blocks__container');
  if (!faqBlockContainer) return;

  const faqBlockBtns = [...faqBlockContainer.querySelectorAll('button')];

  for (const btn of faqBlockBtns) {
    new FaqButton(btn);
  }
}

class FaqButton {
  constructor(buttonNode) {
    this.buttonNode = buttonNode;
    this.controlledNode = false;

    const id = this.buttonNode.getAttribute('aria-controls');

    if (id) {
      this.controlledNode = document.getElementById(id);
    }

    this.buttonNode.setAttribute('aria-expanded', 'false');
    this.hideContent();

    this.buttonNode.addEventListener('click', this.onClick.bind(this));
    this.buttonNode.addEventListener('focus', this.onFocus.bind(this));
    this.buttonNode.addEventListener('blur', this.onBlur.bind(this));
  }

  showContent() {
    if (this.controlledNode) {
      this.buttonNode.classList.add('-is-active');
      this.controlledNode.parentElement.style.display = 'block';
    }
  }

  hideContent() {
    if (this.controlledNode) {
      this.buttonNode.classList.remove('-is-active');
      this.controlledNode.parentElement.style.display = 'none';
    }
  }

  toggleExpand() {
    if (this.buttonNode.getAttribute('aria-expanded') === 'true') {
      this.buttonNode.setAttribute('aria-expanded', 'false');
      this.hideContent();
    } else {
      this.buttonNode.setAttribute('aria-expanded', 'true');
      this.showContent();
    }
  }

  onClick() {
    this.toggleExpand();
  }

  onFocus() {
    this.buttonNode.classList.add('focus');
  }

  onBlur() {
    this.buttonNode.classList.remove('focus');
  }
}

// Används även på produktsidor
export function addHtmlToColorChoiceProducts() {
  const classToCheck = 'wl-color-element-added';
  // Ta ut alla produkter som inte redan har fått elementet tillagt
  // Vi måste också kolla related-item-produkter eftersom de inte får produktklassen av någon idiotisk anledning jag hade för tre år sen..
  const allProductListProductsWithMultipleColors = [
    ...document.querySelectorAll(
      '.products .product[data-has-color-choice]:not(.' +
        classToCheck +
        '), .products .related-item[data-has-color-choice]:not(.' +
        classToCheck +
        ')'
    )
  ];

  for (const productListProduct of allProductListProductsWithMultipleColors) {
    const hasMultipleColorsString = productListProduct.dataset.hasColorChoice;
    const productSkuElement = productListProduct.querySelector('.product-sku');

    if (!productSkuElement || !hasMultipleColorsString) continue;

    const colorChoiceIndicatorElement = document.createElement('div');
    colorChoiceIndicatorElement.classList.add('wl-color-indicator__container');
    colorChoiceIndicatorElement.textContent = hasMultipleColorsString;

    productSkuElement.before(colorChoiceIndicatorElement);

    productListProduct.classList.add(classToCheck);
  }
}

function addClickHandlerToProductList() {
  const productList = document.querySelector('.product-list');

  productList.addEventListener('click', function (e) {
    const urlToSet = window.location.href;

    if (e.target.closest('.type-product') && $(e.target.closest('.type-product')).index() > 20) {
      const productIndex = $(e.target.closest('.type-product')).index();
      const newSessionValue = urlToSet + '_wl-product-index_' + productIndex;
      sessionStorage.setItem('currentUrl', newSessionValue);
    }
  });
}

function removeDuplicateProducts() {
  const productListEls = document.querySelectorAll('.product.type-product');
  const seenProductIDclasses = new Set();

  for (const element of productListEls) {
    const postIdClass = getPostIdClass(element);

    if (!postIdClass) continue;

    if (seenProductIDclasses.has(postIdClass)) {
      element.remove();
    } else seenProductIDclasses.add(postIdClass);
  }
}

function getPostIdClass(element) {
  return element.className.split(/\s+/).find((cls) => cls.startsWith('post-'));
}
